import React, { useEffect } from 'react';
import _ from 'lodash';
import { object, func, bool } from 'prop-types';
import { checkUserAgentData } from '../../services/Api/User/UserService';
import { GOOGLE_SITE_KEY } from '../../constants/defaults';
import Input from '../common/Input';
import DateInput from '../common/DateInput';
import { useTranslation } from 'react-i18next';
import { Errors } from '../../constants/errors';

const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const SignupInput = ({ formData, handleFormState, autoFocus }) => {
  const handleLoaded = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, {
          action: 'signup'
        })
        .then(token => {
          (async () => {
            const checkValidAgent = await checkUserAgentData(token);
            if (checkValidAgent.success) {
              // allow user to click on signup
            }
          })();
        });
    });
  };
  const { t } = useTranslation();
  useEffect(() => {
    if (API.ALLOW_GOOGLE_CAPTCHA) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${GOOGLE_SITE_KEY}`;
      script.addEventListener('load', handleLoaded);
      document.body.appendChild(script);
    }
  }, []);

  const {
    FName,
    FNameErr,
    LName,
    LNameErr,
    birthDate,
    birthDateErr,
    // phoneNumber,
    // phoneNumberErr,
    Email,
    EmailErr
  } = formData;

  const handleInputChange = event => {
    const { name, value } = event.target;
    handleFormState({ ...formData, [name]: value, emailKickboxErr: false });
  };

  const handleInputBlur = event => {
    const { name, value } = event.target;
    if (name === 'birthDate') {
      const ageError = _.calculateAgeNew(value);
      switch (ageError) {
        case 'Invalid':
          handleError(name, 'Date');
          break;
        case 'Greater':
          handleError(name, 'MaxAge');
          break;
        case true:
          handleError(name, 'Age');
          break;
        default:
          handleError(name, '');
      }
    } else {
      switch (name) {
        case 'FName':
        case 'LName':
          _.validateName(value)
            ? handleError(name, '')
            : handleError(name, 'FName');
          break;
        case 'Email':
          handleFormState({
            ...formData,
            emailKickboxErr: false,
            EmailErr: _.validateEmail(value) ? '' : Errors.Email
          });
          break;
        default:
          handleError(name, '');
      }
    }
  };

  const handleError = (name, type) => {
    _.setError(handleFormState, formData, name, type);
  };

  return (
    <div>
      <div className="noteLabel">
        {t(
          'Your name and date of birth must match what is on file at your pharmacy.'
        )}
      </div>
      <Input
        label={t('First name')}
        name="FName"
        placeholder="John"
        value={FName}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        error={FNameErr}
        autoFocus={autoFocus}
        autoComplete="given-name"
      />
      <Input
        parentClass="float-right"
        label={t('Last name')}
        name="LName"
        placeholder="Smith"
        value={LName}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        error={LNameErr}
        autoComplete="family-name"
      />
      <DateInput
        birthDate={birthDate}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        birthDateErr={t(birthDateErr)}
        autoComplete="bday"
      />
      {/* <PhoneInput
        parentClass="float-right"
        phoneNumber={phoneNumber}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        phoneErr={phoneNumberErr}
      /> */}
      <Input
        parentClass="fullWidth"
        label={t('Email')}
        type="email"
        name="Email"
        value={Email}
        placeholder={t('example@domain.com')}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        error={t(EmailErr)}
        autoComplete="email"
      />
      {/* <PasswordComp formData={formData} handleFormState={handleFormState} /> */}
    </div>
  );
};

SignupInput.propTypes = {
  formData: object,
  handleFormState: func,
  autoFocus: bool
};

SignupInput.defaultProps = {
  formData: {},
  handleFormState: () => {},
  autoFocus: true
};
export default SignupInput;
